import {
  ICategoryAsset,
  ICategoryLiteAsset,
  ICategoryLiteWithChildsAsset,
} from "models/Assets/ICategoryAsset";

interface IFilterSubCategoryByUrlName {
  categories: ICategoryLiteWithChildsAsset[];
  mainCatReportingName: string;
  lang: string;
  url_name: string;
}

export const filterMainCategoryByCatId = (
  categories: ICategoryLiteWithChildsAsset[],
  categoryId?: number
): ICategoryLiteWithChildsAsset => {
  if (!categoryId || !categories) return null;
  const [category] = categories.filter((c) => c.id == categoryId);
  return category;
};

export const filterMainCategoryBySubCatId = (
  categories: ICategoryAsset[],
  subCategoryId?: number | string
): ICategoryAsset => {
  if (!subCategoryId || !categories) return null;
  let foundSubCat: ICategoryAsset;
  categories.forEach((cat) => {
    if (!foundSubCat) {
      const [subCat = null] = cat.subCategories.filter(
        (s) => s.id == subCategoryId
      );
      if (subCat) {
        foundSubCat = subCat;
      }
    }
  });
  return filterMainCategoryByCatId(categories, foundSubCat?.parent_id);
};

export const filterSubCategoriesBySubCatId = (
  categories: ICategoryLiteWithChildsAsset[],
  subCategoryId?: number | string
): ICategoryLiteAsset => {
  if (!subCategoryId || !categories) return null;
  let foundSubCat;
  categories.forEach((cat) => {
    if (!foundSubCat) {
      const [subCat = null] = cat.subCategories.filter(
        (s) => s.id == subCategoryId
      );
      if (subCat) {
        foundSubCat = subCat;
      }
    }
  });
  return foundSubCat;
};

export const filterSubCategoriesBySubCatUrlName = (
  categories: ICategoryLiteWithChildsAsset[],
  subCatUrlName: string,
  lang: string
): ICategoryLiteAsset => {
  if (!subCatUrlName || !categories) return null;
  let foundSubCat: ICategoryLiteAsset;
  categories.forEach((cat) => {
    if (!foundSubCat) {
      const [subCat = null] = cat.subCategories.filter((s) => {
        return s[`url_name_${lang}`] === subCatUrlName;
      });
      if (subCat) {
        foundSubCat = subCat;
        return;
      }
    }
  });
  return foundSubCat;
};

export const filterRealEstateForSaleMainCategory = (
  categories: ICategoryLiteWithChildsAsset[]
): ICategoryLiteWithChildsAsset =>
  filterMainCategoryByReportingName(categories, "RealEstateForSale");

const filterMainCategoryByReportingName = (
  categories: ICategoryLiteWithChildsAsset[],
  reportingName: string
): ICategoryLiteWithChildsAsset => {
  const [mainCat] = categories.filter(
    (c) => c.reporting_name === reportingName
  );
  return mainCat;
};

export const filterRealEstateForSaleSubCategoryByUrlName = (
  categories: ICategoryLiteWithChildsAsset[],
  url_name?: string
): ICategoryLiteWithChildsAsset | null => {
  if (!url_name) return null;
  const [subCat = null] = filterRealEstateForSaleMainCategory(
    categories
  ).subCategories.filter(
    (c) =>
      c.url_name_ar === url_name ||
      c.url_name_en === url_name ||
      c.url_name === url_name
  );
  return subCat;
};

export const filterMobileAndTabletMainCategory = (
  categories: ICategoryLiteWithChildsAsset[]
): ICategoryLiteWithChildsAsset =>
  filterMainCategoryByReportingName(categories, "MobileTablet");


export const filterMobileOrTabletSubCategoryByUrlName = (
  categories: ICategoryLiteWithChildsAsset[],
  lang: string,
  url_name?: string
): ICategoryLiteWithChildsAsset | null => {
  if (!url_name) return null;
  const [subCat = null] = filterMobileAndTabletMainCategory(
    categories
  ).subCategories.filter(
    (c) => c[`url_name_ar`] === url_name || c[`url_name_en`] === url_name || c.url_name === url_name
  );

  return subCat;
};
